import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Alert, Spinner, Row, Col, Card, Badge } from 'react-bootstrap';
import { LanguageProvider } from '../../core/language-provider';
import { DataManager } from '../../core/data-manager';
import { ResourceManager } from '../../core/resource-manager';
import courseDefault from '../../assets/course.jpg';
import CardCorso from '../Card/Corso';


import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, FreeMode, Scrollbar, Navigation } from "swiper/modules";

import 'swiper/css';
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/navigation";



export default function CorsiInEvidenza() {

    const navigate = useNavigate();
    const [errors, setErrors] = useState('');
    const [data, setData] = useState(null);


    useEffect(() => {
        init()
    }, []);


    async function init() {
        let constraints = [
            {
                "fieldName": "inEvidence",
                "type": "value",
                "value": 1
            }
        ]
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var response = await DataManager.searchItems('course', 1, 1000, sorting, '', [], constraints)
        if (response.success === 1) {
            var t = response.body
            setData(t)
            console.warn('courses in evidence', t)
        }
        else {
            setErrors(LanguageProvider.get('errors.get'))
            console.warn(response)
        }
    }


    function openCourse(item) {
        navigate('/course/' + item.id)
    }


    if (data) {
        if (data.length) {
            return (
                <Container fluid className='p-0 pb-5 course-slider' style={{ backgroundColor: '#f7f7f7' }}>
                    <Container fluid={'md'}>
                        <Row>
                            <Col>
                                <div className='text-center my-5'>
                                    <h3>Corsi in evidenza</h3>
                                </div>

                                <Swiper
                                    slidesPerView={'auto'}
                                    spaceBetween={30}
                                    freeMode={false}
                                    grabCursor={true}
                                    scrollbar={true}
                                    pagination={false}
                                    navigation={true}
                                    modules={[FreeMode, Pagination, Scrollbar, Navigation]}
                                    className="home-course-swiper"
                                >
                                    {data.map((item, j) => {
                                        var image = item.image ? ResourceManager.getFileUrl(item.image, 'course') : courseDefault
                                        return (
                                            <SwiperSlide key={j} style={{ "width": '340px' }}>
                                                <CardCorso data={item}></CardCorso>
                                                {/* <Card role="button" onClick={() => openCourse(item)} className='mt-3 mb-3 text-dark' style={{ borderRadius: '20px' }}>
                                                    <Card.Img variant="top" src={image} style={{ borderStartEndRadius: '20px', borderStartStartRadius: '20px' }} />
                                                    <Card.ImgOverlay>
                                                        <Card.Title className='text-white'>
                                                            <b>{item.name}</b>
                                                        </Card.Title>
                                                    </Card.ImgOverlay>
                                                    <Card.Body>
                                                        <Card.Text>Corsi | {item.idCategory.name}</Card.Text>
                                                        <Card.Text style={{ minHeight: '70px' }}>
                                                            {item.description && (
                                                                <>
                                                                    {item.description.length > 110 ? item.description.substring(0, 110) + '...' : item.description}
                                                                </>
                                                            )}
                                                        </Card.Text>
                                                        <Card.Text>
                                                            <Badge>{item.episodes.length} lezioni</Badge>
                                                        </Card.Text>
                                                    </Card.Body>
                                                </Card> */}
                                            </SwiperSlide>
                                        )
                                    })}

                                </Swiper>
                            </Col>
                        </Row>


                    </Container>
                </Container>
            );
        }
        else {
            return <></>
        }
    }
    else {
        return (
            <Container fluid="md" className='mt-5 mb-5'>
                {errors.length > 0 &&
                    <Alert variant='danger'>
                        {errors}
                    </Alert>
                }
                <div className='text-center p-5'>
                    <Spinner animation="border" variant="primary" />
                    <p className='text-primary'>{LanguageProvider.get('defaults.loading')}</p>
                </div>
            </Container>
        )
    }

};